import Spinner from '~components/Spinner/Spinner';

export default function LoadingPage() {
    return (
        <section className="min-h-screen w-full flex items-center justify-center align-middle">
            <Spinner color="blue" size="large" />
        </section>
    );
}
